export default "__VITE_ASSET__O34PprQY__"